<template>
  <div class="container">
    <text-input
      v-mask="'##/##/####'"
      hint="DD/MM/YYYY"
      label="Fecha de nacimiento"
      name="fechaNacimiento"
      pattern="[0-9]*"
      inputmode="numeric"
      @input="onInput"
      @click="$emit('click')"
      :value="value"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
    />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import TextInput from "@/components/core/TextInput";
import { isValidDate } from "@/utils";

export default {
  name: "DateField",
  components: { TextInput },
  directives: {
    mask
  },
  props: {
    value: String,
    required: Boolean,
    subhint: String
  },
  data() {
    return {
      validationError: null,
      checked: false
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
      if (this.checked) {
        this.isValid(val);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid();
    },

    isValid(val) {
      // Por problema de sincronía con v-bind, paso el valor
      // por parámetro en onInput
      let value = val ? val : this.value;

      /* Sobreescribir método de validación */
      if (value && !isValidDate(value)) {
        // La fecha no es válida
        this.validationError = "La fecha no es válida";
        return false;
      }

      // La fecha es válida
      this.validationError = null;
      return true;
    }
  }
};
</script>

<style scoped></style>
